/**
 * @file /src/Components/BugBountyProgram/BugBountyProgram.js
 * @author Jatin Siwach
 */

import React from 'react';
import styles from './BugBountyProgram.module.css';

const BugBountyProgram = () => {
    
    return (
        <>
            <div className={styles.container}>
                <div className={styles.row}>
                    <div className="col-md-12">
                        <div className={styles.aboutCon}>
                            <h1 className={styles.h1}>Drishti Bug Bounty Program</h1>
                            <hr></hr>
                            
                            <h3 className={styles.h3}>Bug Bounty Program</h3>
                            <p className={styles.p}>
                                We take security seriously at Drishti Group. If you are a security researcher or expert
                                and believe you've identified security-related issues with Drishti Group's website or 
                                apps, we would appreciate you disclosing it to us responsibly.
                            </p>

                            <p className={styles.p}>
                                Our team is committed to addressing all security issues in a responsible and timely 
                                manner, and we ask the security community to give us the opportunity to do so 
                                before disclosing them publicly. Please submit a detailed description of the issue to 
                                us, along with the steps to reproduce it. We trust the security community to make 
                                every effort to protect our user's data and privacy.
                            </p>

                            <h3 className={styles.h3}>Disclosure Policy</h3>
                            <p className={styles.p}>
                                Let us know as soon as possible upon discovery of a potential security issue, and we'll 
                                make every effort to quickly resolve the issue.
                            </p>
                            <p className={styles.p}>
                                Provide us a reasonable amount of time to resolve the issue before any disclosure to the public or a third-party.
                            </p>
                            <p className={styles.p}>
                                Make a good faith effort to avoid privacy violations, destruction of data, and 
                                interruption or degradation of our service. Only interact with accounts you own or 
                                with the explicit permission of the account holder.
                            </p>
                            
                            <h3 className={styles.h3}>How to Report?</h3>
                            <p className={styles.p}>
                                To help us process your report efficiently, please follow these instructions:
                            </p>

                            <h4 className={styles.h4}>Subject Format:</h4>
                            <p className={styles.p}>
                                Include <code>X-Bug-Bounty: your_email@example.com</code> in the email subject line (replace with your actual email).
                            </p>

                            <h4 className={styles.h4}>Send To:</h4>
                            <p className={styles.p}>
                                <code>bugbounty@groupdrishti.in</code>
                            </p>

                            <p className={styles.p}>
                                <strong>Note:</strong> Reports without the required subject format may not be reviewed promptly.
                            </p>

                            
                            <h3 className={styles.h3}>Scope</h3>
                            <p className={styles.p}>
                                The scope of issues is limited to technical vulnerabilities in the Drishti Group website 
                                or mobile apps. Please do not attempt to compromise the safety or privacy of our 
                                users (so please use test accounts), or the availability of Drishti Group through DoS 
                                attacks or spam. We also request you not to use vulnerability testing tools that 
                                generate a significant volume of traffic.
                            </p>
                            <p className={styles.p}>
                                The Following Assets are in scope: - 
                            </p>
                            <ul className={styles.list}>
                                <li>Drishtilearningapp.com</li>
                                <li>Drishti Learning App (Android)</li>
                                <li>Drishti Learning App (iOS)</li>
                                <li>Drishti Learning App (Windows)</li>
                            </ul>
                            <h3 className={styles.h3}>Rewards</h3>
                            <p className={styles.p}>
                                We will reward reports according to the severity of their impact on a case-by-case 
                                basis as determined by our security team. We may pay more for unique, hard-to-find 
                                bugs; we may also pay less for bugs with complex prerequisites that lower the risk of 
                                exploitation.
                            </p>
                            <p className={styles.p}>
                                Below, you can find examples of vulnerabilities and their impacts grouped by our 
                                severity ranking. This is not an exhaustive list and it is designed to give you insight on 
                                how we rate vulnerabilities.
                            </p>

                            <h3 className={styles.h4}>Critical</h3>
                            <hr/>
                            
                            <ul className={styles.list}>
                                <li>Remote Code Execution (RCE) - able to execute arbitrary commands on a remote device</li>
                                <li>SQL Injection - able to read Personally Identifiable Information (PII) or other sensitive data / full read/write access to a database</li>
                                <li>Server-Side Request Forgery (SSRF) - able to pivot to internal application and/or access credentials (not blind)</li>
                                <li>Information Disclosure - mass PII leaks including data such as names, emails, phone numbers and addresses (Combined)</li>
                                <li>Extraction of Paid Videos.(Encrypted Videos)</li>
                                <li>Account Takeover (ATO) - with no or minimal user interaction. (DLA)</li>
                                <li>Server information (with credentials & critical information)</li>
                                <li>Broken Authentication / Authorization.</li>
                            </ul>

                            <h3 className={styles.h4}>High</h3>
                            <ul className={styles.list}>
                                <li>2FA Bypass Techniques - circumventing two-factor authentication to take over accounts</li>
                                <li>JWT Token Manipulation - forging or modifying tokens for unauthorized access</li>
                                <li>Race Conditions - allowing duplicate submissions, overriding locks or breaking workflows</li>
                                <li>Business Logic Errors - bypassing functional workflows or controls (e.g. free access, skipped payment)</li>
                                <li>Request/Response data padding bypass on Android / iOS App</li>
                                <li>SQL Injection - able to perform queries with limited access</li>
                                <li>Insecure Direct Object Reference (IDOR) - write access to sensitive data or unauthorized fields</li>
                                <li>Cross-Site Request Forgery (CSRF) - leading to account takeover</li>
                                <li>Subdomain Takeover - with PoC showing data access or unauthorized actions</li>
                                <li>Information Disclosure - leaked valid credentials</li>
                                <li>Stored Cross-Site Scripting (XSS) - stored XSS with access to non HttpOnly cookies</li>
                                <li>Request / Response data Decryption on Android / IOS and Windows App.</li>
                            </ul>

                            <h3 className={styles.h4}>Medium</h3>
                            <ul className={styles.list}>
                                <li>ATO - required user interaction</li>
                                <li>IDOR - read access to objects on horizontal / Vertical axis.</li>
                                <li>XSS - XSS with access to other user cookies</li>
                                <li>XSS - POST based XSS (with CSRF bypass)</li>
                            </ul>

                            <h3 className={styles.h4}>Low</h3>
                            <ul className={styles.list}>
                                <li>CSRF - able to modify important information (authenticated)</li>
                                <li>Directory listings</li>
                                <li>XSS - Without access to cookies/Auth Data</li>
                                <li>Subdomain Takeover - on an unused subdomain</li>
                            </ul>

                            <h3  className={styles.h3}>To promote the discovery and reporting of 
                                vulnerabilities and increase user safety, we ask 
                                that you:
                            </h3>

                            <p className={styles.p}>
                                Give us a reasonable time to respond to the issue before making any information 
                                about it public.
                            </p>
                            <p className={styles.p}>
                                Not access or modify data without the explicit permission of the owner.
                            </p>
                            <p className={styles.p}>
                                Act in good faith not to degrade the performance of our services (including denial of service).
                            </p>
                            <p className={styles.p}>
                                We only reward the first reporter of a vulnerability. Public disclosure of the vulnerability will result in disqualification from the program
                            </p>


                            <h4 className={styles.h4}>Non-qualifying vulnerabilities / Known Issues</h4>

                            <ul className={styles.list}>
                                <li>Informative Bugs</li>
                                <li>Server information page (no credentials)</li>
                                <li>Broken Link Hijacking issues are categorized as low severity and are not eligible for rewards.</li>
                                <li>Credential leakage reports are considered informational if two-factor authentication (2FA) is in place.</li>
                                <li>SSL Pinning / Root Detection Bypass</li>
                            </ul>

                            <h4 className={styles.h4}>Not Applicable & Out-of-Scope Bugs</h4>
                            <ul className={styles.list}>
                                <li>Theoretical vulnerabilities without actual proof of concept</li>
                                <li>SQL Error observed, but SQL Injection is not exploitable</li>
                                <li>Links to invalid/expired pages (only valid if you can demonstrate an actual takeover of an official Drishti IAS social media account linked to on every page)</li>
                                <li>Invalid or missing SPF (Sender Policy Framework) records (incomplete or missing SPF/DKIM/DMARC)</li>
                                <li>CSRF with negligible security impact (e.g. adding to favourites, adding to cart, subscribing to a non-critical feature)</li>
                                <li>Assets that do not belong to Drishti Group</li>
                                <li>Missing security headers that do not lead to direct exploitation</li>
                                <li>Exposure of internal IP address or domains</li>
                                <li>Internally known issues, duplicate issues, or issues which have already been made public</li>
                                <li>Vulnerabilities that require physical access to a user’s device</li>
                                <li>Issues that have no security impact (e.g. failure to load a web page)</li>
                                <li>Vulnerabilities only exploitable on out-of-date browsers or platforms</li>
                                <li>Email verification deficiencies, expiration of password reset links, and password complexity policies</li>
                                <li>Reports from automated tools or scans</li>
                                <li>Vulnerabilities related to auto-fill web forms</li>
                                <li>Issues related to unsafe SSL/TLS cipher suites or protocol version</li>
                                <li>Lack of security flags in cookies</li>
                                <li>Any activity (like DoS/DDoS) that disrupts our services</li>
                                <li>Email or mobile enumeration (e.g. the ability to identify emails via password reset)</li>
                                <li>Self-XSS</li>
                                <li>Cache-control related issues</li>
                                <li>Installation path permissions</li>
                                <li>Use of known vulnerable libraries without actual proof of concept</li>
                                <li>Information disclosure with minimal security impact (e.g. stack traces, path disclosure, directory listings, logs)</li>
                                <li>Content spoofing</li>
                                <li>Tab-nabbing</li>
                                <li>Disclosure of information that does not present a significant risk</li>
                                <li>Clickjacking / UI redressing</li>
                                <li>Issues that require unlikely user interaction</li>
                            </ul>


                            <h4 className={styles.h4}>In Scope</h4>
                            <ul className={styles.list}>
                                <li>drishtilearningapp.com</li>
                                <li>Drishti Learning App (Android)</li>
                                <li>Drishti Learning App (iOS)</li>
                                <li>Drishti Learning App (Windows)</li>
                            </ul>

                            <h4 className={styles.h4}>Out of Scope</h4>
                            <ul className={styles.list}>
                                <li>drishtiias.com</li>
                                <li>drishtiteachingexams.com</li>
                                <li>drishtijudiciary.com</li>
                                <li>drishticuet.com</li>
                                <li>sscdrishti.com</li>
                                <li><code>*.groupdrishti.com</code></li>
                                <li><code>*.groupdrishti.in</code></li>
                                <li>Any other domains associated with Drishti Group</li>
                            </ul>

                            <p className={styles.p}>
                                <strong>Note:</strong> In cases of <strong>Remote Code Execution (RCE)</strong> and <strong>Full Server Compromise</strong>, out-of-scope domains may still be eligible for bounty rewards based on severity.
                            </p>
                            <p className={styles.p}>
                                Rewards may vary depending on actual impact and exploitability, even if they fall under a listed category.
                            </p>
                            <div className={styles.publishedDate}>
                                Published on: <span>July 8, 2025</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BugBountyProgram;
